// 礼包类型
exports.AIPkgType = {
    Daily: "daily", // 每日特惠
    Revive: "stage", // 关末
}

// 每日礼包显示红色倒计时的毫秒计数
exports.AI_CD_RED_LIMIT = 3 * 60 * 60 *1000;    

// 打点类型
exports.AIDCType = {
    Daily: 1,    // 每日礼包弹窗
    Revive: 2,   // 关末复活
    ReviveOther: 3, // 占据了AI的关末礼包位，但不是AI礼包
    DailyMarket: 4, // 商店每日礼包
    ReviveMarket: 5,    // 商店复活礼包
}

// 礼包购买货币
exports.AIPayType =  {
    RMB: 1, // 人民币
    HappyCoin: 2    // 风车币
}

// 购买结果
exports.AIBuyResult = {
    Success: "pay successfully",
    Fail: "pay failed",
    Cancel: "cancel"
}